<template>
  <!-- Begin Page Content -->
  <div class="">
    <div class="card shadow-sm border-0 my-4">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div class="text-md-start text-center">
            <h4 class="m-0 font-weight-bold text-primary">
              Holidays <span class="badge bg-primary ms-2" style="font-size: 0.6em; vertical-align: middle;">{{ currentYear }}</span>
            </h4>
          </div>
          
          <!-- Count Display -->
          <div>
            <h6 class="text-end fw-normal mb-0">Count: {{ rows.length }}</h6>
          </div>
        </div>

        <!-- Holidays Table -->
        <div class="table-responsive">
          <vue-good-table
            :rows="rows"
            :columns="columns"
            :sort-options="{
              enabled: true,
              initialSortBy: { field: 'date', type: 'asc' },
            }"
            styleClass="vgt-table no-border"
          >
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
  <!-- End of Main Content -->
</template>

<script>
import Vue from "vue";
import user from "@/ajax/user";
import moment from "moment";
moment.locale("en");
import { mapActions } from "vuex";

export default {
  name: "Holidays",
  data: function () {
    return {
      columns: [
        {
          label: "Date",
          field: "date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "dd/MM/yyyy",
          thClass: "custom-th",
          tdClass: "custom-td",
        },
        {
          label: "Details",
          field: "details",
          thClass: "custom-th",
          tdClass: "custom-td",
        },
      ],
      rows: [],
      currentYear: new Date().getFullYear(),
      loading: false,
    };
  },
  methods: {
    ...mapActions("common", ["setCurrentPage"]),

    getHolidays() {
      this.loading = true;
      // Pass the current year to fetch only relevant data
      user.getHolidays(this.currentYear).then((result) => {
        if (result.data.code == 200) {
          this.rows = result.data.data;
        } else {
          this.$swal({
            icon: "error",
            title: "Error",
            text: "Failed to fetch holidays",
          });
        }
        this.loading = false;
      }).catch((error) => {
        console.error("Error fetching holidays:", error);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Failed to fetch holidays",
        });
        this.loading = false;
      });
    },
  },
  mounted() {
    this.setCurrentPage("Holidays");
    this.getHolidays();
  },
};
</script>

<style scoped>
.custom-th {
  background-color: #f8f9fa;
  font-weight: 600;
}

.custom-td {
  vertical-align: middle;
}
</style>

